import { omit } from 'lodash';
import { WeekDayConfiguration } from '../../../shared/contract/week-day-configuration.contract';
import { GeofenceAlarmTrigger } from '../../../shared/enums/geofence-alarm-trigger.enum';
import { TelematicsUnitType } from '../../resources/equipment/enums/telematics-unit-type.enum';
import { AlarmLevel } from '../enums/alarm-level.enum';
import { EquipmentAlarmRuleSelectionType } from '../enums/equipment-alarm-rule-selection-type.enum';
import { UpdateAlarmRuleCommand } from './update-alarm-rule-command.contract';

export interface UpdateEquipmentAlarmRuleCommand {
  limit: number;
  limitDurationUnit?: string;
  timeframeInDays: number;
  globalGeofenceId: string;
  geofenceAlarmTrigger: GeofenceAlarmTrigger;
  alarmLevel: AlarmLevel;
  alarmMessage: string;
  alarmRuleId: string;
  emailRecipients: string[];
  userRolesEmailRecipients?: string[];
  selectionType: EquipmentAlarmRuleSelectionType;
  labels?: string[];
  equipmentTypeIds?: string[];
  timefenceConfiguration?: {
    operatingHoursLimit?: number;
    distanceLimit?: number;
    weekDayConfiguration: WeekDayConfiguration;
  };
  telematicsUnitTypes: TelematicsUnitType[];
}

export function toUpdateEquipmentAlarmRuleCommand(command: UpdateAlarmRuleCommand): UpdateEquipmentAlarmRuleCommand {
  return omit(command, ['alarmType']);
}
